export default __webpack_public_path__ + "static/media/execution.d5f812f7.png";